// From https://chakra-ui.com/community/recipes/using-fonts
// Adapted with fonts from the Bij12 Style guide

import { Global } from "@emotion/react";

const Fonts = () => (
  <Global
    styles={`
      /* latin */
      @font-face {
        font-family: 'Body Font Name';
        font-style: normal;
        font-weight: 600;
        font-display: swap;
        src: url('/assets/fonts/sourcesanspro/SourceSansPro-Light.otf') format('opentype');
      };
      @font-face {
        font-family: 'Body Font Name';
        font-style: normal;
        font-weight: 700;
        font-display: swap;
        src: url('/assets/fonts/sourcesanspro/SourceSansPro-Regular.otf') format('opentype');
      };
      @font-face {
        font-family: 'Body Font Name';
        font-style: normal;
        font-weight: 800;
        font-display: swap;
        src: url('/assets/fonts/sourcesanspro/SourceSansPro-Semibold.otf') format('opentype');
      };
    @font-face {
    font-family: 'Heading Font Name';
    font-style: normal;
    font-weight: 700;
    font-display: swap;
    src: url('/assets/fonts/asap/Asap-Regular.ttf') format('truetype');
    };
    `}
  />
);

export default Fonts;
